import { Dispatch, createContext } from 'react';

import { FileFiltersState } from '@lichtblick/types';

export enum FileFilterType {
  FOLDER = 'folder',
}

export type FileFilterAction = {
  payload: number;
  type: FileFilterType.FOLDER;
};

export const fileFiltersReducer = (state: FileFiltersState, action: FileFilterAction) => {
  switch (action.type) {
    case FileFilterType.FOLDER: {
      return {
        ...state,
        folderId: action.payload,
      };
    }
    default:
      return state;
  }
};

export const FileFilterContext = createContext<{
  dispatchFileFilters: Dispatch<FileFilterAction>;
  fileFilters: FileFiltersState | undefined;
}>({
  dispatchFileFilters: () => {},
  fileFilters: {},
});
